import React from "react";
import PagesWrapper from "../mainpage/PagesWrapper";
import KontaktForm from "./KontaktForm";
import styles from "./Kontakt.module.css";
import { imgIG } from "../../../media/kontakt/export";
import { Section } from "../../../types";
import useWindowDimensions from "../../util/useWindowDimensions";

const Kontakt = ({ bgData }: { bgData: Section[] }) => {
  const { width } = useWindowDimensions();
  const iconWidth = width < 768 ? 15 : 30;
  return (
    <PagesWrapper data={bgData} hasTop={false}>
      <div className={styles.header}>KONTAKT</div>
      <div className={styles.wrapper}>
        <div style={{ flex: 1 }}>
          <KontaktForm />
        </div>
        <div className={styles.text}>
          Uwe Scheutzel <br />
          Julius-Vosseler-Str. 97a <br />
          22527 Hamburg <br />
          Telefon: +49 40 409 601 <br />
          Mobil +49 162 88 77 825 <br />
          uwe_s@gmx.de <br />
          <div>
            <img src={imgIG} alt={"Instagram"} width={iconWidth} /> @uw.sch
          </div>
        </div>
      </div>
    </PagesWrapper>
  );
};

export default Kontakt;
